import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  langs = [
    /*  0 */ { l0: 'Bokningsdatum', l1: 'Booking date' },  
    /*  1 */ { l0: 'Boka', l1: 'Book' },
    /*  2 */ { l0: 'Upptagen', l1: 'Busy' },
    /*  3 */ { l0: 'Kl', l1: 'Time' },  
    /*  4 */ { l0: 'Innan vi kan slutföra bokningen skickar vi en säkerhetskod till din mobiltelefon som du anger nedan:', l1: 'We need to send you a security code before the booking can be finished. Please enter the code below upon reception.' },
    /*  5 */ { l0: 'Tack för din bokning, en bekräftelse har skickats till dig.', l1: 'Thank you for booking with us, a confirmation will be sent to you shortly.' },  
    /*  6 */ { l0: 'Bokningen kunde tyvärr inte genomföras, vänligen försök igen.', l1: 'The booking could not be completed, please try again.' },  
    /*  7 */ { l0: '', l1: '' },  
    /*  8 */ { l0: '', l1: '' },  
    /*  9 */ { l0: '', l1: '' },  
    /* 10 */ { l0: '', l1: '' },  
  ]

  translations = [
    { t0: 'Måndag', t1: 'Monday' },
    { t0: 'Tisdag', t1: 'Tuesday'},
    { t0: 'Onsdag', t1: 'Wednesday'},
    { t0: 'Torsdag', t1: 'Thursday'},
    { t0: 'Fredag', t1: 'Friday'},
    { t0: 'Lördag', t1: 'Saturday'},
    { t0: 'Söndag', t1: 'Sunday'},
    { t0: 'Boka', t1: 'Book'},
    { t0: 'Öppet', t1: 'Open'},
    { t0: 'bokningsbart kl', t1: 'bookable at'},
    { t0: 'bokningsbart', t1: 'bookable'},
    { t0: 'kl', t1: 'at'},
    { t0: 'Bana', t1: 'Lane'},
    { t0: 'Bord', t1: 'Table'},
    { t0: 'Sammanställning', t1: 'Booking information'},
    { t0: 'Datum', t1: 'Date'},
    { t0: 'Avbryt', t1: 'Cancel'},
    { t0: 'Slutför', t1: 'Confirm'},
    { t0: 'Vald', t1: 'Selected'},
    { t0: 'Upptagen', t1: 'Unavailable'},
    { t0: 'Välj antal', t1: 'Select number of'},
    { t0: 'Personer', t1: 'Persons'},
    { t0: 'Välj tid:', t1: 'Select time:'},
    { t0: 'middag', t1: 'dinner'},
    { t0: 'Mobilnummer', t1: 'Mobile phone'},
    { t0: 'Förnamn', t1: 'First name'},
    { t0: 'Efternamn', t1: 'Last name'},
    { t0: 'E-postadress', t1: 'E-mail address'},
    { t0: 'Skicka kod', t1: 'Send code'},
    { t0: 'Säkerhetskod', t1: 'Security code'},
    { t0: 'Övrig information', t1: 'Information'},
    { t0: '', t1: ''},
  ]

  constructor() { }

  get(nr: number, idLang: number): string {
    return this.langs[nr]['l' + idLang] || ''
  }

  translate(str: string, idLang: number) {

    if (idLang == 0) return str

    let s = this.translations.find(t => t.t0.toLowerCase() == str.toLowerCase())

    if (s) return s['t' + idLang]

    return ''

  }

  translateBeginning(str: string, idLang: number): string {

    if (idLang == 0) return str

    let words = str.split(' ')

    let s = this.translations.find(t => t.t0.toLowerCase() == words[0].toLowerCase())

    if (s) {
      words[0] = s['t' + idLang]
      return words.join(' ')
    }

    return ''

  }

  translateWords(str: string, idLang: number): string {

    if (idLang == 0) return str

    let words = str.split(' ')
    let newWords = []

    words.forEach(word => {

      let s = this.translations.find(t => t.t0.toLowerCase() == word.toLowerCase())
      
      if (s) {
        newWords.push(s['t' + idLang])
      } else {
        newWords.push(word)
      }

    })
    
    return newWords.join(' ')

  }

}
